import { useSyncExternalStore } from 'react';

let isOpen = false;
const listeners = new Set();

const notify = () => {
  listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const setIsOpen = (value) => {
  const nextValue = Boolean(value);
  if (isOpen === nextValue) {
    return;
  }
  isOpen = nextValue;
  notify();
};

export const openPenaltyPaymentModal = () => {
  setIsOpen(true);
};

export const closePenaltyPaymentModal = () => {
  setIsOpen(false);
};

const getSnapshot = () => isOpen;

export const usePenaltyPaymentModalState = () => {
  const isModalOpen = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  return {
    isOpen: isModalOpen,
    open: openPenaltyPaymentModal,
    close: closePenaltyPaymentModal,
  };
};
